module.exports = __webpack_public_path__ + "static/media/wurzburgGermany.fc5bf4a8.png";